import { loadStyle } from 'globalutils/fmUtils';
import React, { lazy, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import ExportPopup from './ExportPopup';
import filterListForm from './Form';
import { checkServiceProvider } from './serviceProviderConfig';
import ParentStyled from './style';
import { downloadFile } from './util';

const Styled = loadStyle(ParentStyled, 'modules/DataTableWithSearchExport');
const layout = window?.$environment?.CURRENT_LAYOUT;
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));

const TopActions = ({
  filterSuccess,
  columns,
  i18n,
  needExportAll,
  exportAllData,
  apiIds,
  needFilter,
  list,
  needSearch,
  fileName,
  exportCsvData,
  exportPdfData,
  logBook,
  getDocumentToken,
  needExportPopup,
  setPagination,
  isOldView,
}) => {
  const history = useHistory();

  const [values, setValues] = useState({
    driver: '',
    dateFrom: '',
    dateTo: '',
  });
  const [isExportClicked, setIsExportClicked] = useState(false);
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;

  const selectChange = (e) => {
    filterSuccess(e);
    setPagination(true);
  };

  const handleExportAsCsv = async () => {
    try {
      const query = new URLSearchParams(history.location.search);
      const beBaseUrl = window?.$environment?.BE_BASE_URL;

      if (getDocumentToken) getDocumentToken({ apiId: 'exportUser' });

      let pageUrl = '/violations/exportNonDeletedViolations?token=';
      if (window.location.href.includes('alerts')) {
        pageUrl = '/alerts/export/CSV?token=';
      } else if (window.location.href.includes('driverStatus')) {
        pageUrl = `/driverStatus/export/CSV?id=${query.get('id')}&token=`;
      }

      const url = `${beBaseUrl}${pageUrl}${logBook.documentToken}`;
      await downloadFile(url, 'file.csv');
    } catch (error) {
      console.error('Failed to export CSV:', error);
    }
  };

  return (
    <Styled.Wrapper>
      {isOldView && (
        <div className="exportAlertSection">
          <Export
            src={mediaUrls.new_export_circle}
            data={[...columns]}
            filename={i18n.t('Export')}
            toolTip={i18n.t('common.exportData')}
            className="exportContainer export"
            onClick={() => {
              window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? handleExportAsCsv() : setIsExportClicked(true);
            }}
            buttonName={i18n.t('Export')}
          />
          {needExportAll && (
            <Export
              src={mediaUrls.exportAllCircle}
              addFilter={checkServiceProvider('topaction_addFilter', SERVICE_PROVIDER, false)}
              filename={i18n.t('Export All')}
              toolTip={i18n.t('common.exportAll')}
              className="exportContainer"
              onClick={() => {
                exportAllData({ apiId: apiIds.export });
              }}
              buttonName={i18n.t('Export All')}
            />
          )}
        </div>
      )}
      {needFilter && filterListForm(values, list, filterSuccess, setValues, i18n, setPagination)}
      <div style={{ display: 'flex', gap: '5px' }}>
        {needSearch && (
          <Styled.SearchWrapper>
            <Search
              onChange={(e) => selectChange(e)}
              default={list?.list}
              fromData
              placeHolder={i18n.t('dashboard.tabs.driverStatus.heading')}
              query={'driver_Status'}
              id="driver_Status"
            ></Search>
          </Styled.SearchWrapper>
        )}
        {!isOldView && (
          <>
            <Export
              src={mediaUrls.new_export_circle}
              data={[...columns]}
              filename={i18n.t('Export')}
              toolTip={i18n.t('common.export')}
              className={needExportPopup ? 'exportHistory exportContainer' : 'exportContainer'}
              onClick={() => {
                setIsExportClicked(true);
              }}
              buttonName={i18n.t('Export')}
            />
            {needExportAll && (
              <Export
                src={mediaUrls.exportAllCircle}
                addFilter={
                  checkServiceProvider('topaction_addFilter', SERVICE_PROVIDER, false) || window.$environment.WHITE_THEME
                }
                filename={i18n.t('Export All')}
                toolTip={i18n.t('common.exportAll')}
                className="exportContainer"
                onClick={() => {
                  exportAllData({ apiId: apiIds.export });
                }}
                buttonName={i18n.t('Export All')}
              />
            )}
          </>
        )}
      </div>

      <ExportPopup
        isOpen={isExportClicked}
        setIsOpen={setIsExportClicked}
        list={list}
        fileName={fileName}
        exportCsvData={exportCsvData}
        exportPdfData={exportPdfData}
        Styled={Styled}
        logBook={logBook}
        history={history}
        getDocumentToken={getDocumentToken}
      />
    </Styled.Wrapper>
  );
};
export default TopActions;
